module.exports = __webpack_public_path__ + "fonts/FuturaPT-Medium.5fbd70c5.woff2";